// extracted by mini-css-extract-plugin
export default {"searchInput":"SearchInput_searchInput__RAWMt","searchIcon":"SearchInput_searchIcon__1SVhQ"};